import { render, staticRenderFns } from "./navbar-tabs.vue?vue&type=template&id=2245b6ec&scoped=true"
import script from "./navbar-tabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./navbar-tabs.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./navbar-tabs.vue?vue&type=style&index=0&id=2245b6ec&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2245b6ec",
  null
  
)

export default component.exports